import './descope-phone-input-box-internal';
import '../../descope-text-field';

import { componentName, PhoneFieldInputBoxClass } from './PhoneFieldInputBoxClass';

customElements.define(componentName, PhoneFieldInputBoxClass);

export { PhoneFieldInputBoxClass, componentName };
